import React from "react";
import FeaturedCamera from "../FeaturedCamera";

const CameraSection = ({ camera }) => {
  return <FeaturedCamera camera={camera} />;
};

export default CameraSection;
